import { observer } from "mobx-react-lite";
import React, {useEffect} from "react";
import ListLayout from "../../../components/layouts/list-layout/list-layout";
import { Button } from "../../../components/inputs/button/button";
import GlobaleEnvironmentSelector from "./components/globale-environment-selector/globale-environment-selector";
import MigrateGlobalEMerchantsIdsInput from "./components/migrate-global-e-merchants-ids-input/migrate-global-e-merchants-ids-input";
import MigrateGlobalEMerchantsResult from "./components/migrate-global-e-merchants-result/migrate-global-e-merchants-result";
import migrateGlobalEMerchantsPageStore from "./stores/migrate-global-e-merchants-page-store";
import useValidationGroup from "../../../hooks/validation-group/validation-group-hook";
import Card from "../../../components/layouts/card/card";
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../components/fonts/font-props";

const MigrateGlobalePlatformCard: React.FC = observer(() => {
    const vGroup = useValidationGroup();

    const parsedMerchantIdsCount = migrateGlobalEMerchantsPageStore.getMerchantIdsCount();
    const isLoadingInitialData = migrateGlobalEMerchantsPageStore.isLoadingInitialData();
    const isSubmittingMigrationRequest = migrateGlobalEMerchantsPageStore.isSubmittingMigrationRequest();

    useEffect(() => {
        migrateGlobalEMerchantsPageStore.fetchInitialData();
    }, []);

    const handleMigrate = () => {
        vGroup.validate();
        if (!vGroup.isValid()) {
            return;
        }
        migrateGlobalEMerchantsPageStore.submitMigrationRequest();
    };

    return (

        <Card isExpanded={true}
            toolbar={{title: 
                <>
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>Create and Migrate Global-E Platform Store </FontBody1> 
                    <FontBody1 color={FONT_COLOR.PRIMARY2}>(backend/global-e)</FontBody1>
                </>
            }}  
        >
            <ListLayout>
                <GlobaleEnvironmentSelector 
                    onChange={migrateGlobalEMerchantsPageStore.setEnvironment} 
                    value={migrateGlobalEMerchantsPageStore.getEnvironment()} 
                />

                <MigrateGlobalEMerchantsIdsInput
                    validationGroup={vGroup}
                />

                <Button
                    onClick={handleMigrate}
                    text="Start migration"
                    hasLoader={true}
                    isLoading={isSubmittingMigrationRequest}
                    disabled={isLoadingInitialData || isSubmittingMigrationRequest || parsedMerchantIdsCount === 0 || !vGroup.isValid()}
                />

                <MigrateGlobalEMerchantsResult />
            </ListLayout>

        </Card>

    );
});

export default MigrateGlobalePlatformCard;
